export default __webpack_public_path__ + "static/media/gangdonggu-seongnaedong-redevelopment-1.bc346a51.jpg";